document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".currency-picker__currency");
  const moneyEls = document.querySelectorAll(".money");
  const cuursEl = document.getElementById("cuurs");
  const cuursEl2 = document.getElementById("cuurs2");
  const pickerEl = document.getElementById("currency-picker");

  const savedCurrency = localStorage.getItem("currency") || "GBP";
  const savedRate = parseFloat(localStorage.getItem("rate")) || 1;

  function formatMoney(amount, currency) {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: currency
    }).format(amount);
  }

  function convertPrices(rate, currency) {
    moneyEls.forEach(el => {
      const base = parseFloat(el.dataset.basePrice);
      if (!base) return;

      const converted = base * rate;
      el.innerText = formatMoney(converted, currency);
    });
  }

  function updateCurrencyLabel(currency) {
    if (cuursEl) {
      cuursEl.textContent = currency;
    }
    if (cuursEl2) {
      cuursEl2.textContent = currency;
    }
  }

  function hidePicker() {
    if (pickerEl) {
      pickerEl.style.display = "none";
    }
  }

  convertPrices(savedRate, savedCurrency);
  updateCurrencyLabel(savedCurrency);

  if (localStorage.getItem("currency")) {
    hidePicker();
  }

  buttons.forEach(btn => {
    btn.addEventListener("click", e => {
      e.preventDefault();

      const currency = btn.dataset.currency;
      const rate = parseFloat(btn.dataset.rate);

      localStorage.setItem("currency", currency);
      localStorage.setItem("rate", rate);

      convertPrices(rate, currency);
      updateCurrencyLabel(currency);
      hidePicker();
    });
  });
});